import { render, staticRenderFns } from "./container_trading.vue?vue&type=template&id=74d486a2&scoped=true&"
import script from "./container_trading.vue?vue&type=script&lang=js&"
export * from "./container_trading.vue?vue&type=script&lang=js&"
import style0 from "./container_trading.vue?vue&type=style&index=0&id=74d486a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d486a2",
  null
  
)

export default component.exports